import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Modal,
  Typography,
  InputLabel,
  Select,
  Button,
  MenuItem,
  Grid,
  FormControl,
} from '@mui/material';

import * as CommonActions from '../../../../../store/actions/common.action';
import { getCommonState } from '../../../../../store/selector/common.selector';
import Services from '../../../../services';
import { IFilterForm } from '../../../../interfaces/filter-form.interface';
import { IExportFilterModal } from '../../../../interfaces/modal.interface';
import { MONTH_LIST_CONSTANT } from '../../../../constants/month.constant';

const styles = {
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { sm: 600, xs: '100%' },
    bgcolor: 'background.paper',
    borderRadius: { sm: '0.5rem', xs: 0 },
    boxShadow: 24,
    overflowY: 'visible',
    p: 4,
  },

  modalButton: {
    marginTop: '.5rem',
    padding: '0.5rem 3rem',
    borderRadius: '2.5rem',
    width: { sm: 'auto', xs: '100%' },
  },
};

const ExportFilterModal = ({ isModalOpen, onClickModal }: IExportFilterModal) => {
  const dispatch = useDispatch();
  const { filters, company } = useSelector(getCommonState);

  const [filterForm, setFilterForm] = useState<IFilterForm>({
    /* eslint-disable camelcase */
    company: '',
    month: '',
    year: '',
    reason: '',
    is_export: 'application',
  });

  const onFilterFormHandler = (identifier: string, value: string) => {
    setFilterForm((prev: IFilterForm) => {
      Services.log(filterForm);
      return {
        ...prev,
        [identifier]: value,
      };
    });
  };

  useEffect(() => {
    if (isModalOpen) {
      dispatch(CommonActions.CommonFetchReportFilters());
      dispatch(CommonActions.CommonFetchAffiliates());
    }
  }, [isModalOpen]);

  return (
    <Modal open={isModalOpen}>
      <Box sx={styles.modalContainer}>
        <Box>
          <Typography sx={{ fontSize: '1.75rem', mb: '2rem' }} color='primary'>
            Export Reports
          </Typography>

          {filters && (
            <Box>
              <Grid container sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Grid item xs={12} sx={{ mb: '1rem' }}>
                  <FormControl fullWidth>
                    <InputLabel>Affiliate Description</InputLabel>

                    <Select
                      fullWidth
                      label='Affiliate Description'
                      value={filterForm.company}
                      onChange={(e) => onFilterFormHandler('company', e.target.value)}
                    >
                      <MenuItem value={''}>All</MenuItem>
                      {company.items &&
                        company.items.map((e: any) => (
                          <MenuItem key={e} value={e}>
                            {e}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sx={{ mb: '1rem' }}>
                  <FormControl fullWidth>
                    <InputLabel>Reason</InputLabel>

                    <Select
                      fullWidth
                      label='Reason'
                      value={filterForm.reason}
                      onChange={(e) => onFilterFormHandler('reason', e.target.value)}
                    >
                      <MenuItem value={''}>All</MenuItem>
                      {filters.reasons &&
                        filters.reasons.map((e: string) => {
                          return (
                            <MenuItem key={e} value={e}>
                              {e}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item md={5.9} xs={12} sx={{ mb: '1rem' }}>
                  <FormControl fullWidth>
                    <InputLabel>Month</InputLabel>

                    <Select
                      fullWidth
                      label='Month'
                      value={filterForm.month}
                      onChange={(e) => onFilterFormHandler('month', e.target.value)}
                    >
                      {MONTH_LIST_CONSTANT.length > 0 &&
                        MONTH_LIST_CONSTANT.map(({ value, label }) => {
                          return (
                            <MenuItem key={value} value={value}>
                              {label}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item md={5.9} xs={12} sx={{ mb: '1rem' }}>
                  <FormControl fullWidth>
                    <InputLabel>Year</InputLabel>

                    <Select
                      fullWidth
                      label='Year'
                      value={filterForm.year}
                      onChange={(e) => onFilterFormHandler('year', e.target.value)}
                    >
                      <MenuItem value={''}>All</MenuItem>
                      {filters.years &&
                        filters.years.map((e: string) => {
                          return (
                            <MenuItem key={e} value={e}>
                              {e}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant='contained'
              sx={{ ...styles.modalButton, mr: '1rem' }}
              onClick={() => onClickModal('confirm', filterForm)}
              disableElevation
            >
              Confirm
            </Button>

            <Button
              color='inherit'
              variant='contained'
              sx={styles.modalButton}
              onClick={() => onClickModal('cancel', filterForm)}
              disableElevation
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ExportFilterModal;
